// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3ZC3W","inner":"Footer_inner__3mZ1Q","nextIcon":"Footer_nextIcon__VmF_g","innerLeft":"Footer_innerLeft__397vj"};